import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { useState } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ModalSizeE } from 'declarations/enums/modal';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import type { NoopT } from 'declarations/types/common';

import useTicketClosePopup from './hooks/useTicketClosePopup';
import { getPopupContentStyle } from './TicketClosePopup.styled';

type TicketApprovePopupPropsT = {
  ticketId: string;
  isOpen: boolean;
  onClose: NoopT;
};

const TicketApprovePopup: FC<TicketApprovePopupPropsT> = ({ ticketId, isOpen, onClose }) => {
  const { isMobile } = useResponsive();
  const { isClosingTicket, handleCloseTicket, handleClosePopup } = useTicketClosePopup();

  const [requestRO, setRequestRO] = useState(false);

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn
      modalTitle="Close Ticket"
      size={ModalSizeE.CLOSE_TICKET}
      width={420}
      height={240}
      popupId={ScrollLockIdE.TicketClosePopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      <Typography variant="body1" color="text.primary" align={isMobile ? 'center' : 'left'}>
        Are you sure you want to close the ticket?
      </Typography>
      <FormControlLabel
        control={
          <Switch checked={requestRO} onChange={(e): void => setRequestRO(e.target.checked)} />
        }
        label="Repull RO"
        sx={{ my: 1 }}
      />
      <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} sx={{ mt: 2 }}>
        <Button
          variant="contained"
          disabled={isClosingTicket}
          onClick={handleCloseTicket([ticketId], requestRO, onClose)}
        >
          {isClosingTicket ? 'Closing...' : 'Close'}
        </Button>
      </Box>
    </Popup>
  );
};

export default TicketApprovePopup;
